var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookDarkGreyThickIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V12.6C0 13.5838 0.816243 14.4 1.8 14.4H7.7291C7.82205 14.6629 7.99413 14.8906 8.2217 15.0517C8.44926 15.2129 8.72115 15.2996 9 15.3C9.27885 15.2996 9.55074 15.2129 9.7783 15.0517C10.0059 14.8906 10.1779 14.6629 10.2709 14.4H16.2C17.1838 14.4 18 13.5838 18 12.6V0H11.7C10.6102 0 9.662 0.518622 9 1.29199C8.338 0.518622 7.38984 0 6.3 0H0ZM1.8 1.8H6.3C7.305 1.8 8.1 2.595 8.1 3.6H9.9C9.9 2.595 10.695 1.8 11.7 1.8H16.2V12.6H1.8V1.8ZM11.7 4.5V6.3H13.5V4.5H11.7ZM11.7 7.2V10.8H13.5V7.2H11.7Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDarkGreyThickIcon);
export default __webpack_public_path__ + "static/media/book-dark-grey-thick-icon.74e8fe272245c3c9da7537aa36619c23.svg";
export { ForwardRef as ReactComponent };